import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import ImageViewer from 'react-simple-image-viewer';
// import Image from 'next/image'
import { Markup } from 'interweave';

import {
    useAppDispatch,
    useAppSelector,
} from 'app/hooks';
import {
    toggleArrorEnable,
    selectQuestionFilter,
} from 'features/filters/filterSlice';
import { useCallback, useEffect, useState } from 'react';
import PdfViewModal from 'components/elements/Modal/PdfViewModal'
import Fancybox from 'components/elements/ImageViewer/Fancybox';
import Carousel from 'components/elements/ImageViewer/Carousel';
import { toggleArrorFuntion } from '../../../utils/service';
const SolutionPreview = () => {
    const dispatch = useAppDispatch();
    const {
        questionData,
        questionDetail,
        pending,
        error,
    }: any = useAppSelector(selectQuestionFilter);
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [previewImages, setPreviewImages] = useState([]);
    const [isPDFViewerOpen, setIsPDFViewerOpen] = useState(false);
    const [selectedPdf, setSelectedPdf] = useState('');
    const [isImages, setIsImages] = useState(false);

    const openImageViewer = useCallback((index: number) => {
        // document.body.classList.add('overflow-hidden');
        // setCurrentImage(index);
        // setIsViewerOpen(true);
        toggleArrorFuntion(false)
    }, []);
    const closeImageViewer = () => {
        // document.body.classList.remove('overflow-hidden');
        // setCurrentImage(0);
        // setIsViewerOpen(false);
        dispatch(toggleArrorEnable(true))
    };
    useEffect(() => {
        setIsImages(false)
        if (questionDetail?.solution_images?.length > 0) {
            // let images = questionDetail.solution_images.map((image: any) => image.url);
            // setPreviewImages(images)
            // setTimeout(() => {
            setIsImages(true)
            // }, 100)
            // setTimeout(() => {
            //     const container = document.getElementById("solutionCarousel");
            //     if(container){
            //         const options = { infinite: false };
            //         console.log('container.....',container)
            //         new Carousel(container, options);
            //     }
            // }, 2000)

        }

    }, [questionDetail])

    const myLoader = ({ src, width, quality }: any) => {
        return `${src}?w=${width}&q=${quality || 100}`
    }

    const rendarPreviewSlider = () => {
        return questionDetail.solution_images.map((image: any, key: number) =>
            <div key={`sol_slider_${key}`} className="previewImage f-carousel__slide">
                <a href={image.url} data-fancybox={`solution-preview`} onClick={() => openImageViewer(key)} data-caption="">
                    <img className="thumb-image"
                        src={image.url}
                        alt="Picture of the solution"
                        width={"100%"}
                        height={"100%"} />
                </a>
            </div>
        )

        // return questionDetail.solution_images.map((image: any, key: number) =>
        //     <div key={`sol_slider_${key}`} className="previewImage" onClick={() => openImageViewer(key)}>
        //         <img
        //             className="thumb-image"
        //             src={image.url}
        //             alt="Picture of the author"
        //             width={"100%"}
        //             height={"100%"}
        //         />
        //     </div>
        // )
    }

    const rendarPreviewPDFSlider = () => {
        return questionDetail.solution_links.map((item: any, key: number) =>
        <div key={`slider_${key}`} className="previewPdf">
            <a data-fancybox data-type="iframe" data-width="100%"
       data-height="100%" href={`${item.url}#toolbar=0&javascript:disableClick();`}>
                <div className="pdf-icon">
                    <i className="fa fa-file-pdf me-2"></i>
                </div>
            </a>
        </div>
    )
        // return questionDetail.solution_links.map((item: any, key: number) =>
        //     <div key={`slider_${key}`} className="previewPdf">
        //         <div className="pdf-icon" onClick={() => {
        //             setSelectedPdf(item.url)
        //             setIsPDFViewerOpen(true)
        //         }} ><i className="fa fa-file-pdf me-2"></i></div>
        //     </div>
        // )
    }
    const handleClose = () => {
        setIsPDFViewerOpen(false)
    }

    const renderSolutionPreview = () => (
        <>
            <div className="row">
                <div className="col-md-12">
                    <span className="fs-5">Solution No. - {questionDetail.sequence_no}</span>
                    <hr className="text-white" />

                    <div className="image-viewer">
                        {isImages && questionDetail?.solution_images?.length > 0 &&
                            <Fancybox
                                options={{
                                    Carousel: {
                                        infinite: false,
                                    },
                                }}
                               
                            >
                                {/* <AwesomeSlider infinite={false} animation="foldOutAnimation"> */}
                                <Carousel options={{
                                        Carousel: {
                                            infinite: false,
                                        },
                                    }}>

                                    {rendarPreviewSlider()}
                                </Carousel>
                                {/* </AwesomeSlider> */}
                            </Fancybox>
                        }


                    </div>
                    <div className="mt-5">
                        {/* <span className="text-white fs-5">Solution</span> */}
                        <p className="text-white mt-2">
                            <Markup content={questionDetail.solution} />

                        </p>
                    </div>

                    {questionDetail?.solution_links?.length > 0 &&
                        <div className="mt-1">
                            <Fancybox
                                options={{
                                    Carousel: {
                                        infinite: false,
                                    },
                                }}
                            >
                            {rendarPreviewPDFSlider()}
                            </Fancybox>
                        </div>
                    }
                </div>

            </div>
            {/* <div style={{ zIndex: 99999 }}>
                {isViewerOpen && (
                    <ImageViewer
                        backgroundStyle={{ backgroundColor: '#030822de' }}
                        src={previewImages}
                        currentIndex={currentImage}
                        disableScroll={false}
                        closeOnClickOutside={true}
                        onClose={closeImageViewer}
                    />
                )}
            </div> */}
            <PdfViewModal title="PDF" link={selectedPdf} isOpen={isPDFViewerOpen} handleClose={handleClose} />
        </>
    );


    return (
        <div className="d-flex flex-column flex-shrink-0 text-white sidebar col-md-4 text-start mb-pd-x-5">
            {questionData.length > 0 ?
                renderSolutionPreview() : <div className="empty-data">Solution preview will be display here.</div>}
        </div>
    )
}

export default SolutionPreview;
